export default __webpack_public_path__ + "static/agd-32127894cc2e694a56afd5e2ca14737b-32127894cc2e694a56afd5e2ca14737b.jpeg";